import { Col, DesignTokens, Row } from "melco-ui";
import {
  DisplayWrapper,
  EmptyMachineGroupWrapper,
  getTimeDifference,
  machineStatusDisplayLookup,
  NA,
  backgroundColorLookup,
} from "../helper/reportingHelper";
import { isEmpty } from "lodash-es";
import { MachineStatusGridItem } from "../status/grid/MachineStatusGridItem";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  ReportingMelcoMachineStatisticsModelsView,
  ReportingMelcoMachineStatisticsModelsViewGroups,
} from "melco-shared-logic";

type DisplayMachinesStatusViewWithoutGroupedProps = {
  viewDetail: ReportingMelcoMachineStatisticsModelsView;
  activeTooltip: string | null;
  onToggleTooltip: (machineName: string) => void;
};

const { spacings } = DesignTokens;

export const DisplayMachineStatusViewWithoutGrouped: React.FC<
  DisplayMachinesStatusViewWithoutGroupedProps
> = ({ viewDetail, activeTooltip, onToggleTooltip }) => {
  const { t } = useTranslation();
  const [numOfMachines, setNumOfMachines] = useState(0);

  useEffect(() => {
    let machineCount = 0;
    if (viewDetail?.group_list && viewDetail?.group_list?.length > 0) {
      viewDetail?.group_list?.map(
        (group: ReportingMelcoMachineStatisticsModelsViewGroups) => {
          if (group?.machine_list && group?.machine_list?.length > 0) {
            machineCount = machineCount + group.machine_list.length;
          }
        }
      );
      setNumOfMachines(machineCount);
    } else {
      setNumOfMachines(0);
    }
  }, [viewDetail]);

  return (
    <>
      <DisplayWrapper>
        {viewDetail?.group_list && viewDetail?.group_list?.length > 0 && (
          <Row gutter={[spacings.middle, spacings.middle]}>
            {viewDetail?.group_list?.map((group: any) => {
              return (
                <>
                  {group?.machine_list?.length > 0 ? (
                    <>
                      {group?.machine_list?.map((machine: any) => {
                        let machineStateValues = machine?.last_status
                          .split(",")
                          .map((value: any) => value.trim()) // Trim spaces
                          .join("-"); // Join with hyphen
                        // Create a lookup key by combining `a` and the trimmed and joined `b`
                        let lookupKey = "";
                        lookupKey = machine?.event_type ?? "";

                        if (lookupKey == "MACHINE_STOP") {
                          if (machine?.stop_type == "ESTOP")
                            machineStateValues = machine?.stop_type;
                        }

                        if (!isEmpty(machineStateValues))
                          lookupKey = lookupKey + "-" + machineStateValues;
                        // Find the matching result for the lookup key
                        const result = machineStatusDisplayLookup[lookupKey];
                        const backgroundColor =
                          backgroundColorLookup[
                            result?.bgColorId ? result.bgColorId : ""
                          ];
                        // console.log(
                        //   "Not grouped 401 ",
                        //   lookupKey,
                        //   " ",
                        //   JSON.stringify(result),
                        //   " ",

                        //   machine?.device_id,
                        //   " ",
                        //   machine?.name
                        // );
                        console.log(
                          machine?.device_id ? machine?.device_id : "",
                          "   ",
                          machine?.name ? machine?.name : "",
                          " ",
                          machine?.event_type ? machine?.event_type : "",
                          " ",
                          result?.textId
                            ? t(`view.status.${result?.textId}` as string, {
                                defaultValue: "Unknown",
                              })
                            : "NA",
                          "       ",
                          result?.bgColorId
                            ? result?.bgColorId + "-color ---> "
                            : "      ",

                          backgroundColor,
                          " "
                        );
                        return (
                          <Col xs={24} md={6} xl={6}>
                            {/* <MachineStatusGridItem
                              machineName={machine.name}
                              status={result ?? NA}
                              tooltip={
                                machine?.inactive
                                  ? t("view.tooltip.content")
                                  : undefined
                              }
                              isActive={
                                activeTooltip ===
                                viewDetail.id + "" + machine.device_id
                              }
                              onToggle={onToggleTooltip}
                              keyForTooltip={
                                viewDetail.id + "" + machine.device_id
                              }
                            /> */}
                            <MachineStatusGridItem
                              key={
                                viewDetail.id +
                                "" +
                                group.name +
                                "" +
                                machine.device_id
                              }
                              keyForTooltip={
                                viewDetail.id +
                                "" +
                                group.name +
                                "" +
                                machine.device_id
                              }
                              machineName={machine.name}
                              status={result ?? NA}
                              isActive={
                                activeTooltip ===
                                viewDetail.id +
                                  "" +
                                  group.name +
                                  "" +
                                  machine.device_id
                              }
                              onToggle={onToggleTooltip}
                              tooltip={
                                machine?.inactive
                                  ? getTimeDifference(machine?.last_sync_date) +
                                    " " +
                                    t("view.status.ago")
                                  : undefined
                              }
                            />
                          </Col>
                        );
                      })}
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
          </Row>
        )}
        {numOfMachines == 0 && (
          <EmptyMachineGroupWrapper>
            <Row gutter={[spacings.middle, spacings.middle]}>
              <Col xs={24} md={24} xl={24}>
                <div style={{ textAlign: "center" }}>
                  {t("view.no_machine_in_any_group")}
                </div>
              </Col>
            </Row>
          </EmptyMachineGroupWrapper>
        )}
      </DisplayWrapper>
    </>
  );
};
